<template>
  <div class="mini-hub mini-people">
    <div class="inner">
      <img :src="post.featured_image_url" alt="" class="featured-image" />

      <etiquette
        v-bind:post-type="post.type"
        :etiquette-type="post.etiquette_type"
      />

      <p class="date" v-html="post.string_date"></p>

      <h3 class="title" v-html="title_linked"></h3>

      <p
        class="excerpt"
        v-if="post.excerpt.rendered != ''"
        v-html="post.excerpt.rendered"
      ></p>

      <tags :tagsArray="post.tags" />

      <Button :link="post.link" :postType="post.type" />
    </div>
  </div>
</template>

<script>
import Etiquette from "../parts/Etiquette";
import Button from "../parts/Button";
import Tags from "../parts/Tags";

export default {
  name: "People",
  components: {
    Etiquette,
    Button,
    Tags,
  },
  props: {
    post: Object,
  },
  computed: {
    title_linked: function () {
      return (
        '<a href="' + this.post.link + '">' + this.post.title.rendered + "</a>"
      );
    },
  },
};
</script>
